import React from "react";

import loadingGif from "./assets/images/loading.svg";
import "./assets/css/style.css";

function Loading() {
  return <div className="loading-container"></div>;
}

export default Loading;
